var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Color",
    "data-name": "Logo / Color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.221,
    height: 14.168,
    viewBox: "0 0 180.221 14.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M2.936,9.347c.082,1.593,1.458,2.42,3.786,2.42h.324c2.187,0,3.219-.609,3.219-1.574,0-.885-.749-1.417-2.591-1.713l-2.6-.354C1.791,7.576.4,6.514.4,4.074.4,1.89,2.339,0,6.409,0c3.907,0,6.276,1.732,6.56,4.526H10.033C9.85,3.188,8.574,2.4,6.57,2.4H6.247c-1.924,0-3.037.649-3.037,1.5,0,.945.648,1.377,2.247,1.633l2.662.354c3.3.531,4.961,1.948,4.961,4.21,0,2.637-2.207,4.074-6.176,4.074-4.272,0-6.823-1.633-6.9-4.821Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M0,0H2.794V8.186c0,2.2,1.215,3.384,3.483,3.384H6.6c2.267,0,3.482-1.181,3.482-3.384V0h2.794V8.343c0,3.445-2.226,5.628-6.439,5.628C2.167,13.97,0,11.806,0,8.343Z",
    transform: "translate(14.623 0.197)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M0,0H12.128V2.4H3.5a.7.7,0,0,0-.708.689V5.884h8.2v2.4H3.5a.7.7,0,0,0-.708.689v4.8H0Z",
    transform: "translate(29.402 0.197)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M0,0H12.128V2.4H3.5a.7.7,0,0,0-.708.689V5.884h8.2v2.4H3.5a.7.7,0,0,0-.708.689v4.8H0Z",
    transform: "translate(42.919 0.197)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    "data-name": "Fill 10",
    d: "M0,13.774H2.794V0H0Z",
    transform: "translate(56.45 0.197)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_12",
    "data-name": "Fill 12",
    d: "M14.173,0H10.762L7.086,5.1,3.411,0H0L4.678,6.492a.676.676,0,0,1,0,.79L0,13.774H3.411l3.675-5.1,3.676,5.1h3.411L9.5,7.283a.673.673,0,0,1,0-.79Z",
    transform: "translate(60.396 0.197)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_13",
    "data-name": "Fill 13",
    d: "M0,0V2.755H2.125a.7.7,0,0,1,.708.689V5.51H5.669V0Z",
    transform: "translate(84.226 0.197)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_14",
    "data-name": "Fill 14",
    d: "M0,2.755H2.835V0H0Z",
    transform: "translate(75.722 11.216)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_15",
    "data-name": "Fill 15",
    d: "M11.339,10.331V8.265H9.213a.7.7,0,0,1-.708-.69V5.51H6.378a.7.7,0,0,1-.708-.689V2.755H3.543a.7.7,0,0,1-.708-.689V0H0V5.51H2.126a.7.7,0,0,1,.708.689V8.265H4.961a.7.7,0,0,1,.708.689V11.02H7.8a.7.7,0,0,1,.709.689v2.067h5.669V11.02H12.048a.7.7,0,0,1-.709-.689",
    transform: "translate(75.721 0.197)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_16",
    "data-name": "Fill 16",
    d: "M12.735,11.374v2.4H0V0H12.531V2.4H3.5a.7.7,0,0,0-.708.689v2.4h8.522v2.4H3.5a.7.7,0,0,0-.708.69v2.794Z",
    transform: "translate(92.729 0.197)",
    fill: "#ee3d8a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_17",
    "data-name": "Fill 17",
    d: "M16.479,0,9.858,13.774H6.64L0,0H3.1L8.28,10.9,13.422,0Z",
    transform: "translate(105.888 0.197)",
    fill: "#ee3d8a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_18",
    "data-name": "Fill 18",
    d: "M12.735,11.374v2.4H0V0H12.531V2.4H3.5a.7.7,0,0,0-.708.689v2.4h8.522v2.4H3.5a.7.7,0,0,0-.708.69v2.794Z",
    transform: "translate(123.347 0.197)",
    fill: "#ee3d8a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_19",
    "data-name": "Fill 19",
    d: "M13.605,0V13.774H10.163L2.795,3.484v10.29H0V0H3.563l7.249,10.114V0Z",
    transform: "translate(138.053 0.197)",
    fill: "#ee3d8a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_20",
    "data-name": "Fill 20",
    d: "M5,2.4H0V0H14.212V2.4h-5a.7.7,0,0,0-.709.689V13.773H5.709V3.089A.7.7,0,0,0,5,2.4",
    transform: "translate(152.831 0.197)",
    fill: "#ee3d8a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_21",
    "data-name": "Fill 21",
    d: "M2.936,9.347c.082,1.593,1.458,2.42,3.786,2.42h.324c2.187,0,3.219-.609,3.219-1.574,0-.885-.749-1.417-2.591-1.713l-2.6-.354C1.791,7.576.394,6.514.394,4.074.394,1.89,2.339,0,6.409,0c3.907,0,6.277,1.732,6.56,4.526H10.033C9.849,3.188,8.575,2.4,6.57,2.4H6.247c-1.924,0-3.038.649-3.038,1.5,0,.945.648,1.377,2.248,1.633l2.662.354c3.3.531,4.96,1.948,4.96,4.21,0,2.637-2.206,4.074-6.175,4.074-4.272,0-6.823-1.633-6.9-4.821Z",
    transform: "translate(167.142)",
    fill: "#ee3d8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewlogo);
export default __webpack_public_path__ + "static/media/newlogo.9a070ac45439b68446851875b987279b.svg";
export { ForwardRef as ReactComponent };